import { useLocation } from '@reach/router';

export default function useSearchParams(): Record<string, string> {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    return Object.fromEntries(params);
}